import Loadable from '@townsquare/loadable';
import { topicRoute } from '@townsquare/routes/topic-page';

import { topicResource } from './resources/topic';
import { topicAsideResource } from './resources/topic-aside';

const TopicPageLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "topic-view" */ './ui/TopicPage'),
  loading: () => null,
});

const TopicPageAsideLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "topic-view-aside" */ './ui/TopicPageAside'),
  loading: () => null,
});

topicRoute.component = TopicPageLoadable;
topicRoute.aside = TopicPageAsideLoadable;
topicRoute.resources = [topicResource, topicAsideResource];
export const topicRouterRoute = topicRoute;
